import { getCategoryHref } from '../../utils/common/category';
import { STORY_TITLE_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'storyTitleGeneratorType',
      analyticsName: 'story_title_type',
      textLabel: 'Generate titles for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: STORY_TITLE_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Story',
        value: getCategoryHref(STORY_TITLE_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'storyTitleGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'story_titles_generator',
      placeholder: 'Try "fun story about growing up" or "creative bit about building houses"',
      textLabel: 'Describe the story’s topic',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: STORY_TITLE_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
